// ponytail: aproximación equirectangular, menos de 0.5% de error a estas latitudes y
// distancias. Alcanza para ordenar sucursales y mostrar los km en línea recta; si alguna
// vez se pide distancia de manejo, va Google Distance Matrix.
const KM_PER_DEGREE = 111.32;

// Comparable entre sí, sin la raíz: se usa para ordenar por cercanía.
export const squaredDegrees = (from, to) => {
    const dLat = to.lat - from.lat;
    const dLng = (to.lng - from.lng) * Math.cos((from.lat * Math.PI) / 180);
    return dLat * dLat + dLng * dLng;
};

// null cuando falta la ubicación del usuario o las coordenadas de la sucursal, para
// poder distinguir "no compartió ubicación" de "está a 0 km".
export const distanceInKm = (from, to) => {
    if (!from || !to || to.lat == null || to.lng == null) return null;
    return Math.round(Math.sqrt(squaredDegrees(from, to)) * KM_PER_DEGREE * 10) / 10;
};
